import React, { useState, useEffect } from "react";
import classes from "./index.module.scss";
import { useTranslation } from "react-i18next";
import * as HTTPServices from "../../../api/HTTPServices";
import FormStep1 from "./formStep1";
import * as Toast from "../../../lib/toast";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import FormStep2 from "./formStep2";

function Index() {
  const { t } = useTranslation();
  const [step, setstep] = useState(1);
  const [height, setheight] = useState("");
  const [weight, setweight] = useState("");
  const [job, setjob] = useState("");
  const [bloodtype, setbloodtype] = useState("");
  const [severeـillnessـchek, setsevereـillnessـchek] = useState(false);
  const [severeـillness, setsevereـillness] = useState("");
  const [smoke_chek, setsmoke_chek] = useState(false);
  const [smoke, setsmoke] = useState("");
  const [drink_alcohol_chek, setdrink_alcohol_chek] = useState(false);
  const [drink_alcohol, setdrink_alcohol] = useState("");
  const [addiction, setaddiction] = useState(false);
  const [addiction_text, setaddiction_text] = useState("");
  const [medications_chek, setmedications_chek] = useState(false);
  const [medications, setmedications] = useState("");
  const [regular_exercise, setregular_exercise] = useState(false);
  const [regular_exercise_text, setregular_exercise_text] = useState("");
  const [alergies, setalergies] = useState(false);
  const [alergies_text, setalergies_text] = useState("");
  const [hereditary_illness, sethereditary_illness] = useState(false);
  const [hereditary_illness_text, sethereditary_illness_text] = useState("");
  const [history_disease_1, sethistory_disease_1] = useState(false);
  const [history_disease_2, sethistory_disease_2] = useState(false);
  const [history_disease_3, sethistory_disease_3] = useState(false);
  const [history_disease_4, sethistory_disease_4] = useState(false);
  const [history_disease_5, sethistory_disease_5] = useState(false);
  const [history_disease_6, sethistory_disease_6] = useState(false);
  const [history_disease_7, sethistory_disease_7] = useState(false);
  const [history_disease_8, sethistory_disease_8] = useState(false);
  const [history_disease_9, sethistory_disease_9] = useState(false);
  const [history_disease_10, sethistory_disease_10] = useState(false);
  const [history_disease_11, sethistory_disease_11] = useState(false);
  const [history_disease_12, sethistory_disease_12] = useState(false);
  const [history_disease_13, sethistory_disease_13] = useState(false);
  const [medicalnote, setmedicalnote] = useState("");
  const [loading, setloading] = useState(false);

  useEffect(() => {
    const RequestService = HTTPServices.getMethod(
      "medical_history",
      "",
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        let {
          height,
          weight,
          job,
          bloodtype,
          severeـillnessـchek,
          severeـillness,
          smoke_chek,
          smoke,
          drink_alcohol_chek,
          drink_alcohol,
          addiction,
          addiction_text,
          medications_chek,
          medications,
          regular_exercise,
          regular_exercise_text,
          alergies,
          alergies_text,
          hereditary_illness,
          hereditary_illness_text,
          history_disease_1,
          history_disease_2,
          history_disease_3,
          history_disease_4,
          history_disease_5,
          history_disease_6,
          history_disease_7,
          history_disease_8,
          history_disease_9,
          history_disease_10,
          history_disease_11,
          history_disease_12,
          history_disease_13,
          medicalnote,
        } = response;
        setheight(height);
        setweight(weight);
        setjob(job);
        setbloodtype(bloodtype);
        setsevereـillnessـchek(severeـillnessـchek);
        setsevereـillness(severeـillness);
        setsmoke_chek(smoke_chek);
        setsmoke(smoke);
        setdrink_alcohol_chek(drink_alcohol_chek);
        setdrink_alcohol(drink_alcohol);
        setaddiction(addiction);
        setaddiction_text(addiction_text);
        setmedications_chek(medications_chek);
        setmedications(medications);
        setregular_exercise(regular_exercise);
        setregular_exercise_text(regular_exercise_text);
        setalergies(alergies);
        setalergies_text(alergies_text);
        sethereditary_illness(hereditary_illness);
        sethereditary_illness_text(hereditary_illness_text);
        sethistory_disease_1(history_disease_1);
        sethistory_disease_2(history_disease_2);
        sethistory_disease_3(history_disease_3);
        sethistory_disease_4(history_disease_4);
        sethistory_disease_5(history_disease_5);
        sethistory_disease_6(history_disease_6);
        sethistory_disease_7(history_disease_7);
        sethistory_disease_8(history_disease_8);
        sethistory_disease_9(history_disease_9);
        sethistory_disease_10(history_disease_10);
        sethistory_disease_11(history_disease_11);
        sethistory_disease_12(history_disease_12);
        sethistory_disease_13(history_disease_13);
        setmedicalnote(medicalnote);
      }
    });
  }, []);

  const onSubmit = () => {
    setloading(true);
    const params = new FormData();
    params.append("height", height);
    params.append("weight", weight);
    params.append("job", job);
    params.append("bloodtype", bloodtype);
    params.append("severeـillnessـchek", severeـillnessـchek);
    params.append("severeـillness", severeـillness);
    params.append("smoke_chek", smoke_chek);
    params.append("smoke", smoke);
    params.append("drink_alcohol_chek", drink_alcohol_chek);
    params.append("drink_alcohol", drink_alcohol);
    params.append("addiction", addiction);
    params.append("addiction_text", addiction_text);
    params.append("medications_chek", medications_chek);
    params.append("medications", medications);
    params.append("regular_exercise", regular_exercise);
    params.append("regular_exercise_text", regular_exercise_text);
    params.append("alergies", alergies);
    params.append("alergies_text", alergies_text);
    params.append("hereditary_illness", hereditary_illness);
    params.append("hereditary_illness_text", hereditary_illness_text);
    params.append("history_disease_1", history_disease_1);
    params.append("history_disease_2", history_disease_2);
    params.append("history_disease_3", history_disease_3);
    params.append("history_disease_4", history_disease_4);
    params.append("history_disease_5", history_disease_5);
    params.append("history_disease_6", history_disease_6);
    params.append("history_disease_7", history_disease_7);
    params.append("history_disease_8", history_disease_8);
    params.append("history_disease_9", history_disease_9);
    params.append("history_disease_10", history_disease_10);
    params.append("history_disease_11", history_disease_11);
    params.append("history_disease_12", history_disease_12);
    params.append("history_disease_13", history_disease_13);
    params.append("medicalnote", medicalnote);

    const RequestService = HTTPServices.postMethod(
      "medical_history_set",
      params,
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        Toast.SuccessData("data has been updated");
        setloading(false);
        console.log(`response`, response);
      }
    });
  };

  const handleChange = (e) => {
    if (e.target.type === "checkbox") {
      switch (e.target.name) {
        case "severeـillnessـchek":
          setsevereـillnessـchek(!severeـillnessـchek);
          break;
        case "smoke_chek":
          setsmoke_chek(!smoke_chek);
          break;
        case "drink_alcohol_chek":
          setdrink_alcohol_chek(!drink_alcohol_chek);
          break;
        case "addiction":
          setaddiction(!addiction);
          break;
        case "medications_chek":
          setmedications_chek(!medications_chek);
          break;
        case "regular_exercise":
          setregular_exercise(!regular_exercise);
          break;
        case "alergies":
          setalergies(!alergies);
          break;
        case "hereditary_illness":
          sethereditary_illness(!hereditary_illness);
          break;
        default:
          break;
      }
    } else {
      switch (e.target.name) {
        case "height":
          setheight(e.target.value);
          break;
        case "weight":
          setweight(e.target.value);
          break;
        case "job":
          setjob(e.target.value);
          break;
        case "bloodtype":
          setbloodtype(e.target.value);
          break;
        case "severeـillness":
          setsevereـillness(e.target.value);
          break;
        case "smoke":
          setsmoke(e.target.value);
          break;
        case "drink_alcohol":
          setdrink_alcohol(e.target.value);
          break;
        case "addiction_text":
          setaddiction_text(e.target.value);
          break;
        case "medications":
          setmedications(e.target.value);
          break;
        case "regular_exercise_text":
          setregular_exercise_text(e.target.value);
          break;
        case "alergies_text":
          setalergies_text(e.target.value);
          break;
        case "hereditary_illness_text":
          sethereditary_illness_text(e.target.value);
          break;
        default:
          break;
      }
    }
  };

  const handleChangeStep2 = (e) => {
    switch (e.target.name) {
      case "history_disease_1":
        sethistory_disease_1(!history_disease_1);
        break;
      case "history_disease_2":
        sethistory_disease_2(!history_disease_2);
        break;
      case "history_disease_3":
        sethistory_disease_3(!history_disease_3);
        break;
      case "history_disease_4":
        sethistory_disease_4(!history_disease_4);
        break;
      case "history_disease_5":
        sethistory_disease_5(!history_disease_5);
        break;
      case "history_disease_6":
        sethistory_disease_6(!history_disease_6);
        break;
      case "history_disease_7":
        sethistory_disease_7(!history_disease_7);
        break;
      case "history_disease_8":
        sethistory_disease_8(!history_disease_8);
        break;
      case "history_disease_9":
        sethistory_disease_9(!history_disease_9);
        break;
      case "history_disease_10":
        sethistory_disease_10(!history_disease_10);
        break;
      case "history_disease_11":
        sethistory_disease_11(!history_disease_11);
        break;
      case "history_disease_12":
        sethistory_disease_12(!history_disease_12);
        break;
      case "history_disease_13":
        sethistory_disease_13(!history_disease_13);
        break;
      case "medicalnote":
        setmedicalnote(e.target.value);
        break;
      default:
        break;
    }
  };

  return (
    <div className={classes.mainContainer}>
      <h3 className={classes.title}>
        {t("pages.protectedPages.medicalHistory.title")}
      </h3>
      <hr></hr>
      <div className={classes.formContainer}>
        {/* <h4>{t("pages.protectedPages.medicalHistory.desc")}</h4> */}
        {step === 1 && (
          <FormStep1
            height={height}
            weight={weight}
            job={job}
            bloodtype={bloodtype}
            severeـillnessـchek={severeـillnessـchek}
            severeـillness={severeـillness}
            smoke_chek={smoke_chek}
            smoke={smoke}
            drink_alcohol_chek={drink_alcohol_chek}
            drink_alcohol={drink_alcohol}
            addiction={addiction}
            addiction_text={addiction_text}
            medications_chek={medications_chek}
            medications={medications}
            regular_exercise={regular_exercise}
            regular_exercise_text={regular_exercise_text}
            alergies={alergies}
            alergies_text={alergies_text}
            hereditary_illness={hereditary_illness}
            hereditary_illness_text={hereditary_illness_text}
            handleChange={handleChange}
          />
        )}
        {step === 2 && (
          <FormStep2
            handleChange={handleChangeStep2}
            history_disease_1={history_disease_1}
            history_disease_2={history_disease_2}
            history_disease_3={history_disease_3}
            history_disease_4={history_disease_4}
            history_disease_5={history_disease_5}
            history_disease_6={history_disease_6}
            history_disease_7={history_disease_7}
            history_disease_8={history_disease_8}
            history_disease_9={history_disease_9}
            history_disease_10={history_disease_10}
            history_disease_11={history_disease_11}
            history_disease_12={history_disease_12}
            history_disease_13={history_disease_13}
            medicalnote={medicalnote}
            loading={loading}
            handleSubmit={onSubmit}
          />
        )}

        <div style={{ textAlign: "center" }}>
          <SkipPreviousIcon
            color={step === 1 ? "disabled" : "primary"}
            fontSize="large"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setstep(1);
            }}
          />
          <SkipNextIcon
            color={step === 2 ? "disabled" : "primary"}
            fontSize="large"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setstep(2);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Index;
